<template>
  <v-bottom-sheet v-model="isVisibleBottomSheet">
    <template #activator="{ on, attrs }">
      <div :data-qa="dataQa">
        <v-select
          outlined
          append-icon="ui-icon-arrow-down"
          :disabled="disabled"
          :value="selectedItem"
          :items="items"
          :menu-props="{
            offsetY: true,
            maxWidth: 472,
            maxHeight: 480,
            disabled: useBottomSheet,
            ...selectProps.menuProps,
          }"
          v-bind="{ ...attrs, ...$attrs, ...selectProps }"
          v-on="useBottomSheet ? on : null"
          @change="$emit('select:change', $event)"
        >
          <template
            v-if="!useBottomSheet"
            #item="{ item, attrs: itemAttrs, on: itemOn }"
          >
            <v-list-item
              :style="{ minHeight: '48px' }"
              :data-qa="`${dataQa}_item`"
              v-bind="itemAttrs"
              v-on="itemOn"
              @click="clickListItem(item)"
            >
              <v-list-item-content>
                <v-list-item-title
                  class="text-body-1"
                  :data-qa="`${dataQa}_item_title`"
                >
                  {{ $i18next?.t(item[itemText], options) || item[itemText] }}
                </v-list-item-title>
                <v-list-item-subtitle
                  v-if="item[itemTextSecondary]"
                  class="text-body-2"
                  :data-qa="`${dataQa}_item_subtitle`"
                >
                  {{ $i18next?.t(item[itemTextSecondary], options) || item[itemTextSecondary] }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </template>
          <template #selection>
            <div
              v-if="textSecondaryInPreview"
              class="w-100"
            >
              <div
                class="text-body-1 text-truncate"
              >
                {{ $i18next?.t(selectedItemObject[itemText], options) || selectedItemObject[itemText] }}
              </div>
              <div
                v-if="selectedItemObject[itemTextSecondary]"
                class="text-body-2 icon-secondary--text"
                :style="{ whiteSpace: 'initial' }"
              >
                <!-- eslint-disable max-len vue/max-len -->
                {{ $i18next?.t(selectedItemObject[itemTextSecondary], options) || selectedItemObject[itemTextSecondary] }}
              </div>
            </div>
            <div v-else>
              {{ $i18next?.t(selectedItemObject[itemText], options) || selectedItemObject[itemText] }}
            </div>
          </template>
        </v-select>
      </div>
    </template>
    <v-list
      v-if="useBottomSheet"
      class="overflow-y-auto"
      :data-qa="`${dataQa}_list`"
      v-bind="{
        maxHeight: 480,
        ...bottomSheetListProps,
      }"
    >
      <v-list-item
        v-for="(item, index) in items"
        :key="index"
        :data-qa="`${dataQa}_item`"
        :style="!wideItems
          ? { maxHeight: '48px' }
          : { minHeight: '56px' }"
        @click="clickListItem(item)"
      >
        <v-list-item-content>
          <v-list-item-title
            class="text-body-1"
            :data-qa="`${dataQa}_item_title`"
          >
            {{ $i18next?.t(item[itemText], options) || item[itemText] }}
          </v-list-item-title>
          <v-list-item-subtitle
            v-if="item[itemTextSecondary]"
            class="text-body-2"
            :style="{ whiteSpace: 'initial' }"
            :data-qa="`${dataQa}_item_subtitle`"
          >
            {{ $i18next?.t(item[itemTextSecondary], options) || item[itemTextSecondary] }}
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-icon class="align-self-auto">
          <v-icon v-if="!checkIcon">
            ui-icon-arrow-right
          </v-icon>
          <v-icon
            v-else-if="item[itemValue] === selectedItem"
            color="primary"
          >
            ui-icon-check
          </v-icon>
        </v-list-item-icon>
      </v-list-item>
    </v-list>
  </v-bottom-sheet>
</template>

<script>
export default {
  name: 'SelectBottomSheet',
  model: {
    prop: 'selectedItem',
    event: 'select:change',
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    useBottomSheet: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: () => [],
    },
    selectedItem: {
      type: [String, Number],
      default: null,
    },
    selectProps: {
      type: Object,
      default: () => ({}),
    },
    dataQa: {
      type: String,
      default: 'select_bottom_sheet',
    },
    checkIcon: {
      type: Boolean,
      default: false,
    },
    wideItems: {
      type: Boolean,
      default: false,
    },
    textSecondaryInPreview: {
      type: Boolean,
      default: false,
    },
    bottomSheetListProps: {
      type: Object,
      default: () => ({}),
    },
  },
  data: vm => ({
    isVisibleBottomSheet: false,
    options: { ns: vm.$i18next?.language || 'ru' },
  }),
  computed: {
    itemText() {
      return this.selectProps?.itemText || 'text'
    },
    itemValue() {
      return this.selectProps?.itemValue || 'value'
    },
    itemTextSecondary() {
      return this.selectProps?.itemTextSecondary || 'textSecondary'
    },
    selectedItemObject() {
      return this.items.find(item => item[this.itemValue] === this.selectedItem)
    },
  },
  methods: {
    clickListItem(item) {
      this.$emit('select:change', item[this.itemValue])

      this.isVisibleBottomSheet = false
    },
  },
}
</script>
